import { render } from "./FlooringView.vue?vue&type=template&id=696e0ed3"
import script from "./FlooringView.vue?vue&type=script&lang=js"
export * from "./FlooringView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__